import Main from '@/components/main'
import { ROLE } from '@/common/constants'
import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面不会缓存
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true,
    },
    component: () => import('@/view/login/login.vue'),
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true,
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          hideInMenu: true,
          title: 'Index',
          notCache: true,
          icon: 'md-home',
        },
        component: () => import('@/view/tickets/tickets.vue'),
      },
    ],
  },
  {
    path: '',
    name: 'doc',
    meta: {
      title: '文档',
      href: 'https://lison16.github.io/iview-admin-doc/#/',
      icon: 'ios-book',
      hideInMenu: true,
    },
  },
  {
    path: '/ticket',
    name: 'ticket',
    meta: {
      icon: 'ios-bug',
      title: 'Ticket',
      showAlways: true,
    },
    component: Main,
    children: [
      {
        path: 'newtik',
        name: 'newtik',
        meta: {
          icon: 'md-funnel',
          title: 'New Ticket',
        },
        component: () => import('@/view/tickets/newtik.vue'),
      },
      {
        path: 'tiks',
        name: 'tiks',
        meta: {
          icon: 'md-funnel',
          title: 'Ticket',
        },
        component: () => import('@/view/tickets/tickets.vue'),
      },
      {
        path: 'tiks/:tikid',
        name: 'tikinfo',
        meta: {
          icon: 'md-funnel',
          title: 'Ticket Info',
          hideInMenu: true,
        },
        component: () => import('@/view/tickets/tikinfo.vue'),
      },
      {
        path: 'ppp',
        name: 'ppp',
        meta: {
          icon: 'md-funnel',
          title: 'PPP',
        },
        component: () => import('@/view/tickets/ppp.vue'),
      },
    ],
  },
  {
    path: '/invoice',
    name: 'invoice',
    meta: {
      icon: 'ios-create',
      title: 'Invoice',
      showAlways: true,
      access: [ROLE.ADMIN, ROLE.DEVELOP, ROLE.ACCOUNT],
    },
    component: Main,
    children: [
      {
        path: 'invoice_edit/:invoiceNumber?',
        name: 'InvoiceEdit',
        meta: {
          title: 'InvoiceEdit',
          icon: 'md-funnel',
          access: [ROLE.ADMIN, ROLE.ACCOUNT],
        },
        component: () => import('@/view/invoice/InvoicePage.vue'),
      },
      {
        path: 'invoice',
        name: 'New',
        meta: {
          icon: 'md-funnel',
          title: 'New',
          hideInMenu: true,
        },
        component: () => import('@/view/invoice/invoice.vue'),
      },
      {
        path: 'renew',
        name: 'renew',
        meta: {
          icon: 'md-funnel',
          title: 'Renew',
          hideInMenu: true,
        },
        component: () => import('@/view/invoice/invoice_renew.vue'),
      },
      {
        path: 'um',
        name: 'um',
        meta: {
          icon: 'md-funnel',
          title: 'U&M',
          hideInMenu: true,
        },
        component: () => import('@/view/invoice/invoice_um.vue'),
      },
      {
        path: 'upgrade',
        name: 'upgrade',
        meta: {
          icon: 'md-funnel',
          title: 'Upgrade',
          hideInMenu: true,
        },
        component: () => import('@/view/invoice/invoice_upgrade.vue'),
      },
      {
        path: 'invoiceList',
        name: 'invoiceList',
        meta: {
          icon: 'md-funnel',
          title: 'Invoice List',
          access: [ROLE.ACCOUNT, ROLE.ADMIN],

        },
        component: () => import('@/view/invoice/invoice_list.vue'),
      },
      {
        path: 'edit/:invoiceId?',
        name: 'edit',
        meta: {
          icon: 'md-funnel',
          title: 'Edit',
          hideInMenu: true,
        },
        component: () => import('@/view/invoice/EditPage.vue'),
      },
      {
        path: 'submit/:invoiceId?',
        name: 'submit',
        meta: {
          icon: 'md-funnel',
          title: 'Submit',
          hideInMenu: true,
        },
        component: () => import('@/view/invoice/SubmitPage.vue'),
      },
    ],
  },
  {
    path: '/normalInvoice',
    name: 'normalInvoice',
    meta: {
      icon: 'ios-create',
      title: 'Invoice For Normal',
      showAlways: true,
      access: [ROLE.NORMAL, ROLE.ADMIN, ROLE.DEVELOP],
    },
    component: Main,
    children: [
      {
        path: 'normal_invoiceList',
        name: 'normalInvoiceList',
        meta: {
          icon: 'md-funnel',
          title: 'Normal Invoice List',
        },
        component: () => import('@/view/invoice/normalInvoiceList.vue'),
      },
    ],
  },
  {
    path: '/salesInvoice',
    name: 'salesInvoice',
    meta: {
      icon: 'ios-create',
      title: 'Sales Invoice',
      showAlways: true,
      access: [ROLE.SALES, ROLE.ADMIN, ROLE.DEVELOP],
    },
    component: Main,
    children: [
      {
        path: 'sales_invoiceList',
        name: 'salesInvoiceList',
        meta: {
          icon: 'md-funnel',
          title: 'Invoice List',
        },
        component: () => import('@/view/invoice/salesInvoiceList.vue'),
      },
      {
        path: 'submit/:invoiceId?',
        name: 'salesSubmit',
        meta: {
          icon: 'md-funnel',
          title: 'Submit',
          hideInMenu: true,
        },
        component: () => import('@/view/invoice/SubmitPage.vue'),
      },
    ],
  },
  {
    path: '/license',
    name: 'License',
    meta: {
      icon: 'md-menu',
      title: 'License',
      showAlways: true,
      access: [ROLE.SERVICE, ROLE.ADMIN, ROLE.DEVELOP],
    },
    component: Main,
    children: [
      {
        path: 'new/:invoiceId?',
        name: 'New License',
        meta: {
          icon: 'md-funnel',
          title: 'New Service',
        },
        component: () => import('@/view/license/license.vue'),
      },
      // {
      //   path: 'batch/:invoiceId?',
      //   name: 'New Batch',
      //   meta: {
      //     icon: 'md-funnel',
      //     title: 'New Batch',
      //   },
      //   component: () => import('@/view/license/licenseBatch.vue'),
      // },
      {
        path: 'um/:invoiceId?',
        name: 'UM Service',
        meta: {
          icon: 'md-funnel',
          title: 'UM Service',
        },
        component: () => import('@/view/license/licenseUM.vue'),
      },
      {
        path: 'tech/:invoiceId?',
        name: 'Tech Service',
        meta: {
          icon: 'md-funnel',
          title: 'Tech Service',
        },
        component: () => import('@/view/license/licenseTech.vue'),
      },
      {
        path: 'renew/:invoiceId?',
        name: 'Renew Service',
        meta: {
          icon: 'md-funnel',
          title: 'Renew Service',
        },
        component: () => import('@/view/license/licenseRenew.vue'),
      },
      {
        path: 'upgrade/:invoiceId?',
        name: 'Upgrade Service',
        meta: {
          icon: 'md-funnel',
          title: 'Upgrade Service',
        },
        component: () => import('@/view/license/licenseUpgrade.vue'),
      },
      // {
      //   path: 'pidList/',
      //   name: 'edit license',
      //   meta: {
      //     icon: 'md-funnel',
      //     title: 'Maintain PID',
      //     access: [ROLE.ADMIN, ROLE.DEVELOP],
      //   },
      //   component: () => import('@/view/license/maintainPid.vue'),
      // },
      // {
      //   path: 'fidList/:pid?',
      //   name: 'edit Fid',
      //   meta: {
      //     icon: 'md-funnel',
      //     title: 'Maintain FID',
      //     access: [ROLE.ADMIN, ROLE.DEVELOP],
      //   },
      //   component: () => import('@/view/license/maintainPid.vue'),
      // },

      // {
      //   path: 'licenseReport',
      //   name: 'License Report',
      //   meta: {
      //     icon: 'md-funnel',
      //     title: 'License Report',
      //   },
      //   component: () => import('@/view/license/licenseReport.vue'),
      // },
      // {
      //   path: 'licenseList',
      //   name: 'License List',
      //   meta: {
      //     icon: 'md-funnel',
      //     title: 'License List',
      //   },
      //   component: () => import('@/view/license/licenseList.vue'),
      // },
      // {
      //   path: 'licenseUsageList',
      //   name: 'License Usage List',
      //   meta: {
      //     icon: 'md-funnel',
      //     title: 'License Usage List',
      //   },
      //   component: () => import('@/view/license/licenseUsageList.vue'),
      // }
    ],
  },
  {
    path: '/report',
    name: 'Report',
    meta: {
      icon: 'md-funnel',
      title: 'Report',
      showAlways: true,
    },
    component: Main,
    children: [
      {
        path: 'list',
        name: 'License List',
        meta: {
          icon: 'md-funnel',
          title: 'License List',
        },
        component: () => import('@/view/license/licenseList.vue'),
      },
      {
        path: 'Report',
        name: 'License Report',
        meta: {
          icon: 'md-funnel',
          title: 'License Report',
        },
        component: () => import('@/view/license/licenseReport.vue'),
      },
      {
        path: 'UsageReport',
        name: 'Usage Report',
        meta: {
          icon: 'md-funnel',
          title: 'Usage Report',
        },
        component: () => import('@/view/license/licenseUsageList.vue'),
      },
      {
        path: 'licenseview',
        name: 'licenseview',
        meta: {
          icon: 'md-funnel',
          title: 'Service List',
        },
        component: () => import('@/view/license/licenseView.vue'),
      },
      {
        path: 'paymentInvoice',
        name: 'paymentInvoice',
        meta: {
          icon: 'md-funnel',
          title: 'Invoice Payment Report',
        },
        component: () => import('@/view/invoice/invoicePaymentReport.vue'),
      },
      {
        path: 'invoiceSummary',
        name: 'invoiceSummary',
        meta: {
          icon: 'md-funnel',
          title: 'Invoice Summary',
        },
        component: () => import('@/view/report/invoiceSummary.vue'),
      },
      {
        path: 'aliveReport',
        name: 'aliveReport',
        meta: {
          icon: 'md-funnel',
          title: 'License Alive Report',
        },
        component: () => import('@/view/report/aliveReport.vue'),
      },
    ],
  },
  {
    path: '/umview',
    name: 'umview',
    meta: {
      icon: 'md-funnel',
      title: 'U&M',
      showAlways: true,
      access: [ROLE.SERVICE, ROLE.ADMIN, ROLE.DEVELOP, ROLE.SALES, ROLE.NORMAL],
    },
    component: Main,
    children: [
      // {
      //   path: 'U&M',
      //   name: 'U&M',
      //   meta: {
      //     icon: 'md-funnel',
      //     title: 'U&M',
      //   },
      //   component: () => import('@/view/invoice/umView.vue'),
      // },
      {
        path: 'normal_UM',
        name: 'U&M Normal',
        meta: {
          icon: 'md-funnel',
          title: 'U&M Normal',
          access: [ROLE.SERVICE, ROLE.ADMIN, ROLE.NORMAL, ROLE.SALES],
        },
        component: () => import('@/view/invoice/umViewNormal.vue'),
      },
      {
        path: 'summary_UM',
        name: 'U&M Summary',
        meta: {
          icon: 'md-funnel',
          title: 'U&M Summary',
          access: [ROLE.SERVICE, ROLE.ADMIN, ROLE.NORMAL, ROLE.SALES],
        },
        component: () => import('@/view/invoice/umViewSummary.vue'),
      },
      {
        path: 'detail_UM',
        name: 'U&M Detail',
        meta: {
          icon: 'md-funnel',
          title: 'U&M Detail',
          access: [ROLE.SERVICE, ROLE.ADMIN, ROLE.NORMAL],
        },
        component: () => import('@/view/invoice/umViewDetail.vue'),
      },

    ],
  },
  {
    path: '/settings',
    name: 'Settings',
    meta: {
      icon: 'ios-hammer',
      title: 'Settings',
      showAlways: true,
    },
    component: Main,
    children: [
      {
        path: 'user',
        name: 'user',
        meta: {
          icon: 'ios-hammer',
          title: 'User Setting',
        },
        component: () => import('@/view/settings/users.vue'),
      },
      {
        path: 'admin_user',
        name: 'admin_user',
        meta: {
          icon: 'ios-hammer',
          title: 'Admin Setting',
          access: [ROLE.ADMIN, ROLE.DEVELOP, ROLE.ACCOUNT],
        },
        component: () => import('@/view/settings/adminSetting.vue'),
      },
      {
        path: 'general',
        name: 'general',
        meta: {
          icon: 'md-funnel',
          title: 'Ticket Setting',
          access: [ROLE.ADMIN],
        },
        component: () => import('@/view/settings/general.vue'),
      },
      {
        path: 'invoice_setting',
        name: 'invoice_setting',
        meta: {
          icon: 'md-funnel',
          title: 'Invoice Setting',
          access: [ROLE.ADMIN],
        },
        component: () => import('@/view/settings/invoiceSetting.vue'),
      },
      {
        path: 'um_upload',
        name: 'um_upload',
        meta: {
          icon: 'md-funnel',
          title: 'U&M File Upload',
          access: [ROLE.ADMIN],
        },
        component: () => import('@/view/settings/UMUpload.vue'),
      },
      {
        path: 'transfer_company',
        name: 'transfer_company',
        meta: {
          icon: 'md-funnel',
          title: 'Transfer Company',
          access: [ROLE.ADMIN],
        },
        component: () => import('@/view/settings/TransferCompany.vue'),
      },
    ],
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true,
    },
    component: () => import('@/view/error-page/401.vue'),
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true,
    },
    component: () => import('@/view/error-page/500.vue'),
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true,
    },
    component: () => import('@/view/error-page/404.vue'),
  },
]
